
export const isInvalidHandler = (fieldName) => (fieldName ? true : false);
export const showPasswordHandler = (fieldName) => (fieldName ? true : false);
export const isObjectEmpty = (obj) => {
    if (Object.entries(obj).length === 0) return true;
    return false;
};
export const isArrayEmpty = (arr) => {
    if (arr.length > 0) return false;
    return true
};
export const arrayToString = (arr) => {
    if (arr.length === 1) return arr[0].name;
    else if (arr.length > 1) return arr.map((el) => el.name).join(", ");
};

/* generate query string for search rqt + search Api */
export const generateQuery = (params, data, page, baseUrl) => {
  const searchForm = data;

  // keep only selected params
  const new_params_list = params.filter(el => {
    if (Array.isArray(searchForm[el])) {
      if (searchForm[el].length > 0) return searchForm[el]
    } else {
      if (searchForm[el] !== "") return searchForm[el]
    }
  });

  if (new_params_list.length === 0) return `${baseUrl}?page=${page}`;

  // create query string from existing params
  let query = `${baseUrl}?page=${page}&`;
  query += new_params_list.map(el => Array.isArray(searchForm[el]) ? `${el}=${searchForm[el].map(e => e.value )}` : `${el}=${searchForm[el]}`).join('&');
  return query;
};